import React from 'react';
import {connect} from 'react-redux';
import moment from 'moment';

import DynamicFormErrorBox from '../../../DynamicForms/Components/DynamicFormErrorBox';
import {InformationBox} from '../../../DynamicForms/Styles/dynamicFormStyles';

import {
    insuranceHealthDeclarationCurrentStepAction,
    showAllHealthDeclarationFormErrorsAction,
    saveInsuranceHealthDeclarationAnswersAction
} from '../State/actions';

import {scrollToTop} from '../../../Utils/scroll';
import throttle from '../../../Utils/throttle';

//import {iconCode} from '../../../Style/cssHelpers';

class HealthDeclarationInformationBox extends React.Component {

    saveDraft = () => {
        scrollToTop()
            .then(() => this.props.saveInsuranceHealthDeclaration(true));
    }

    lastStep = (e) => {
        e.preventDefault();
        if (this.props.currentStep > 0) {
            scrollToTop().then(() => {
                this.props.setCurrentStep(this.props.currentStep - 1);
            });
        }
    }

    nextStep = (e) => {
        const allowDraft = !!this.props.data.allowDraft;

        e.preventDefault();
        scrollToTop().then(() => {
            if (this.props.currentStep === 1) {
                this.props.saveInsuranceHealthDeclaration(false, undefined, allowDraft);
            } else {
                this.props.setCurrentStep(this.props.currentStep + 1);
            }
        });
    }

    validateHealthDeclaration = throttle(() => {
        this.props.showAllHealthDeclarationFormErrors();
    }, 200);


    render() {
        const customerInfo = this.props.data.customer;
        const currentStep = this.props.currentStep;
        const allowDraft = !!this.props.data.allowDraft;

        let healthDeclarationButton = null;
        if (currentStep === 0) {
            healthDeclarationButton = (
                <div className="informationBoxBtnContainer">
                    {allowDraft ? (
                        <button
                            className="editBtn"
                            onClick={this.saveDraft}
                        >
                            Spara och fortsätt redigera senare
                        </button>
                    ) : null}
                    <button
                        form="healthDeclarationForm"
                        type="submit"
                        value="Submit"
                        className="nextStepBtn"
                        disabled={!this.props.hdStatus.valid}
                        onClick={this.nextStep}
                        onMouseEnter={this.validateHealthDeclaration}
                        onTouchStart={this.validateHealthDeclaration}
                    >
                        Gå vidare
                    </button>

                    {this.props.data.autoSave && this.props.data.autoSave.timestamp &&
                        <div className="autoSavedDraftNotice">
                            <span>(Utkast autosparat kl. {moment(this.props.data.autoSave.timestamp).format('HH:mm')})</span>
                        </div>
                    }
                </div>
            );
        } else if (currentStep === 1) {
            healthDeclarationButton = (
                <div className="informationBoxBtnContainer">
                    <button
                        className="editBtn"
                        onClick={this.lastStep}
                    >
                        Ändra svar
                    </button>
                    <button
                        className="sendConfirmedAnswersBtn"
                        onClick={this.nextStep}
                    >
                        Skicka
                    </button>
                </div>
            );
        } else if (currentStep === 2) {
            healthDeclarationButton = (
                <div className="informationBoxBtnContainer">
                    <a href={this.props.data.myPagesStartUrl}>
                        <button
                            className="editBtn"
                        >
                            Gå till Mina sidor
                        </button>
                    </a>
                    <a href={this.props.data.insurancePurchaseUrl}>
                        <button
                            className="sendConfirmedAnswersBtn"
                        >
                            Köp fler försäkringar
                        </button>
                    </a>
                </div>
            );
        }

        return (

            <InformationBox>
                <div className="memberInfoContainer">
                    <h3>Dina uppgifter</h3>
                    <p className="memberInfoName">{customerInfo.firstName + ' ' + customerInfo.lastName}</p>
                    <p>{customerInfo.streetAddress}</p>
                    <p className="memberInfoZipCodeArea">{customerInfo.zipCodeArea}</p>
                    <p><span>Personnummer:</span>{customerInfo.idNumber}</p>
                    <p><span>E-postadress:</span>&shy;{customerInfo.emailAddress}</p>
                    <p><span>Telefon:</span>{customerInfo.mobilePhone}</p>
                </div>

                {!this.props.hdStatus.valid &&
                    <DynamicFormErrorBox formInputs={this.props.formInputs} />
                }

                {healthDeclarationButton}
            </InformationBox>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        data: state.healthDeclarationPageData,
        currentStep: state.pageCurrentStep,
        hdStatus: state.healthDeclarationStatus,
        formInputs: state.healthDeclarationFormInputs
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setCurrentStep: (step) => dispatch(insuranceHealthDeclarationCurrentStepAction(step)),
        showAllHealthDeclarationFormErrors: () => dispatch(showAllHealthDeclarationFormErrorsAction()),
        saveInsuranceHealthDeclaration: (isDraft, isAutoSave, allowDraft) => dispatch(saveInsuranceHealthDeclarationAnswersAction(isDraft, isAutoSave, allowDraft))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(HealthDeclarationInformationBox);
